import { render } from "./ClipPool.vue?vue&type=template&id=05bfca2e&scoped=true"
import script from "./ClipPool.vue?vue&type=script&lang=js"
export * from "./ClipPool.vue?vue&type=script&lang=js"

import "./ClipPool.vue?vue&type=style&index=0&id=05bfca2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bfca2e"]])

export default __exports__